import type { SVGProps } from 'react';

const SvgMoneyWallet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M19 8.18V7c0-1.65-1.35-3-3-3H6C4.35 4 3 5.35 3 7v10c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3v-1.18c1.16-.41 2-1.51 2-2.82v-2c0-1.3-.84-2.4-2-2.82M16 18H6c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v1h-.83c-2.22 0-4.05 1.66-4.16 3.79-.06 1.11.33 2.16 1.09 2.97.75.79 1.81 1.25 2.9 1.25h1v1c0 .55-.45 1-1 1zm3-5c0 .55-.45 1-1 1h-2c-.55 0-1.07-.22-1.45-.62s-.58-.93-.55-1.49c.05-1.04 1.03-1.89 2.17-1.89H18c.55 0 1 .45 1 1z"
    />
    <path
      fill="currentcolor"
      d="M15.62 11.08q-.18.075-.33.21c-.18.19-.29.45-.29.71s.11.52.29.71c.19.18.45.29.71.29s.52-.11.71-.29c.18-.19.29-.45.29-.71s-.11-.52-.29-.71a1 1 0 0 0-1.09-.21"
    />
  </svg>
);
export default SvgMoneyWallet;
